"use client";

import { useEffect } from "react";
import { subjectForRef } from "../contact-refs";
import { scrollToContactRef } from "../contact-ref-scroll";

// A ref the contact form recognizes (see contact-refs.ts) brings the form
// into view; the timing lives in contact-ref-scroll.ts. Unknown values (and
// no value at all) are intentionally ignored so the page behaves normally.

export function ContactRefScroller({ targetId }: { targetId: string }) {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const params = new URLSearchParams(window.location.search);
        if (!subjectForRef(params.get("ref"))) return;
        return scrollToContactRef(targetId, window, document);
    }, [targetId]);

    return null;
}
